import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  env = environment;
  isverify = false;
  isverifyed = false;
  isMobileNum = true;
  mobileNum = "";
  counter = 60;

  constructor(private apiService : ApiService, private route: ActivatedRoute,private appComponent : AppComponent,
    private router: Router) { }

  ngOnInit(): void {
  }

  forget(data : any){
    
    this.mobileNum = data.mobile_no;
    const formObj = {
      mobile_no: data.mobile_no,
      ulb_id: this.env.ulb_id
    }
    this.apiService.postCitizenData(`forgot_password`, formObj).subscribe(
      (res: any) => {
        const product = res.data;
        if(res.success = true){
          this.isverify = true;
          this.isMobileNum = false;
          this.startTimer();
        }
      },
      (error) => {
        this.appComponent.showMessageAlert(error.error.message, 'error');
      }
      );

  }

  genrateOtp(){
    const formObj = {
      mobile_no: this.mobileNum,
      ulb_id: this.env.ulb_id
    }
    this.apiService.postCitizenData(`genrate_otp`, formObj).subscribe(
      (res: any) => {
        const product = res.data;
        this.isverify = true;
        this.startTimer();
      },
      (error) => {
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      }
      );
  }

  verifyOtp(data : any){
    const formObj = {
      mobile_no: this.mobileNum,
      ulb_id: this.env.ulb_id,
      otp: data.otp
    }
    this.apiService.postCitizenData(`verify_otp`, formObj).subscribe(
      (res: any) => {
        const product = res.data;
        localStorage.setItem('loginDetails', JSON.stringify(res['data']));
        // this.router.navigate(['/login']);
        if(res.success = true){
          this.isverifyed = true;
          this.isverify = false;
        }
        this.startTimer();
      },
      (error) => {
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      }
      );
  }

  startTimer(){
    this.counter = 60;
    let _interval = setInterval(val => {
       this.counter = +(this.counter - 1);
       if(this.counter == 0) {
         clearInterval(_interval);
       }
     }, 1000);
   }

   resetPassword(data : any){
    const formObj = {
      mobile_no: this.mobileNum,
      new_password: data.password,
      password: null,
    }
    this.apiService.postCitizenData(`reset_password`, formObj).subscribe(
      (res: any) => {
        const product = res.data;
        this.router.navigate(['/user-property-list']);
      },
      (error) => {
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      }
      
      );
   }

   confirmPass(pass: any){
    // console.log(pass);
    pass.form.controls.confirm_password.errors = null;
    if((pass.value.password != '') && (pass.value.confirm_password != '') && (pass.value.password != pass.value.confirm_password)){
      pass.form.controls.confirm_password.setErrors({ notMatch: true });
    }
  }

}
